import React, { useState } from 'react'
import { CommonSelect } from '@/components/common'
import {
  SubSection,
  StyledDemoGrid,
  DemoComponent,
  StyledSizeLabel,
} from '../styled.jsx'

const demoOptions = [
  { id: 'opt-1', name: 'Alpha' },
  { id: 'opt-2', name: 'Beta' },
  { id: 'opt-3', name: 'Gamma' },
  { id: 'opt-4', name: 'Delta' },
]

export const SelectSection = () => {
  const [singleValue, setSingleValue] = useState('')
  const [placeholderValue, setPlaceholderValue] = useState('')
  const [requiredValue, setRequiredValue] = useState('')
  const [errorValue, setErrorValue] = useState('')
  const [disabledValue, setDisabledValue] = useState('opt-2')
  const [readonlyValue, setReadonlyValue] = useState('opt-3')
  const [multiValue, setMultiValue] = useState([])
  const [multiCheckboxValue, setMultiCheckboxValue] = useState([])

  return (
    <>
      {/* Basic Selects */}
      <SubSection
        title='Select Variants'
        description='Single and multiple selection with placeholder and width options'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Basic Variants
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Single Select'
            component={
              <CommonSelect
                id='demo-select-single'
                label='Choose Option'
                options={demoOptions}
                value={singleValue}
                setValue={setSingleValue}
                placeholder='Select...'
                width='220px'
                fullWidth={false}
              />
            }
            value={singleValue}
          />
          <DemoComponent
            label='With Placeholder'
            component={
              <CommonSelect
                id='demo-select-placeholder'
                label='With Placeholder'
                options={demoOptions}
                value={placeholderValue}
                setValue={setPlaceholderValue}
                placeholder='Pick an item'
                width='220px'
                fullWidth={false}
              />
            }
            value={placeholderValue}
          />
          <DemoComponent
            label='Multiple'
            component={
              <CommonSelect
                id='demo-select-multiple'
                label='Multiple Values'
                options={demoOptions}
                value={multiValue}
                setValue={setMultiValue}
                multiple
                showChips={true}
                placeholder='Choose many'
                width='260px'
                fullWidth={false}
              />
            }
            value={multiValue.join(', ')}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Features */}
      <SubSection
        title='Select Features'
        description='Required, error, disabled, readonly, and with checkboxes'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          With Features
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Required'
            component={
              <CommonSelect
                id='demo-select-required'
                label='Required Field'
                options={demoOptions}
                value={requiredValue}
                setValue={setRequiredValue}
                required={true}
                helperText='This field is required'
                width='220px'
                fullWidth={false}
              />
            }
            value={requiredValue}
          />
          <DemoComponent
            label='With Error'
            component={
              <CommonSelect
                id='demo-select-error'
                label='With Error'
                options={demoOptions}
                value={errorValue}
                setValue={setErrorValue}
                error='Please select a valid option'
                width='220px'
                fullWidth={false}
              />
            }
            value={errorValue}
          />
          <DemoComponent
            label='Disabled'
            component={
              <CommonSelect
                id='demo-select-disabled'
                label='Disabled Select'
                options={demoOptions}
                value={disabledValue}
                setValue={setDisabledValue}
                disabled={true}
                width='220px'
                fullWidth={false}
              />
            }
            value={disabledValue}
          />
          <DemoComponent
            label='Readonly'
            component={
              <CommonSelect
                id='demo-select-readonly'
                label='Readonly Select'
                options={demoOptions}
                value={readonlyValue}
                setValue={setReadonlyValue}
                readonly={true}
                width='220px'
                fullWidth={false}
              />
            }
            value={readonlyValue}
          />
          <DemoComponent
            label='Multiple with Checkboxes'
            component={
              <CommonSelect
                id='demo-select-multi-checkbox'
                label='Multi with Checkboxes'
                options={demoOptions}
                value={multiCheckboxValue}
                setValue={setMultiCheckboxValue}
                multiple
                showCheckboxes={true}
                showChips={true}
                width='280px'
                fullWidth={false}
              />
            }
            value={multiCheckboxValue.join(', ')}
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
